<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ujmaH6/tc-custom/9781612832821.jpg?1705893200649" alt="This image is the cover for the book Impossible Realities"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Impossible Realities
      </h1>
      <p class="bookDescription body article font2">
        <p>Impossible Realities is one of the first books to examine the science behind psychic and paranormal activity.  A former Defense Department expert on artificial intelligence, Maureen Caudill provides evidence for a wide range of paranormal phenomena.Impossible Realities presents a wealth of anecdotal and empirical evidence to prove the existence (and power) of:psychokinesis (most famously spoon bending)remote viewingenergy healingtelepathy, animal telepathyprecognitionsurvival after deathreincarnationCaudill presents the strongest case yet for bringing paranormal phenomena from the margins into the realm of the normal and credible. This is a book both for true believers and skeptics alike.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Maureen Caudill
      </h2>
      
      <p class="authorDescription body article">Maureen Caudill spent more than twenty years as a computer scientist, fifteen of those as a researcher in artificial intelligence and neural networks. She was a program manager and Artificial Intelligence researcher working on such advanced projects  as DARPA ("High Performance Knowledge Base" program) and ARDA ("Advanced Question Answering for Intelligence" program).</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Hampton Roads Publishing, Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2671a4ca